<template>
  <div class="mt-3">
    <div class="section mb-2">
      <div class="section_header mb-3">
        <div class="row no-gutters align-items-center justify-content-between">
          <div class="col">
            <h2 class="section_header_title">
              {{ titulo }}
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row gx-4">
        <div class="col-md-3">
          <label class="text-muted mb-1">Deixa filhos</label>
          <p><b>Sim</b></p>
        </div>
      </div>
    </div>

    <div v-for="(filho, index) in arquivoEstruturado"
         :key="index"
         class="BoxParte mb-4">
      <div class="BoxParte_header p-2">
        <h3 class="BoxParte_header_title">
          {{ filho.nome || 'Não informado' }}
        </h3>
      </div>

      <div class="BoxParte_body py-3">
        <div class="row no-gutters align-items-center justify-content-between">
          <div class="col-12 d-inline-flex BoxParte_body_content">
            <div class="d-inline-block col-2">
              <ul class="BoxParte_list">
                <li class="BoxParte_list_item BoxParte_list_title">
                  Idade
                </li>

                <li class="BoxParte_list_item">
                  <strong>
                    {{ filho.idade || 'Não informado' }}
                  </strong>
                </li>
              </ul>
            </div>

            <div class="d-inline-block col-2">
              <ul class="BoxParte_list">
                <li class="BoxParte_list_item BoxParte_list_title">
                  Tipo de idade
                </li>

                <li>
                  <strong>
                    {{ filho.tipo_idade || 'Não informado' }}
                  </strong>
                </li>
              </ul>
            </div>

            <div class="d-inline-block col-2">
              <ul class="BoxParte_list">
                <li class="BoxParte_list_item BoxParte_list_title">
                  Falecido
                </li>

                <li class="BoxParte_list_item">
                  <strong>
                    {{ tratarDados('boolean', filho.filho_falecido) }}
                  </strong>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Filhos',
    props: {
      arquivoEstruturado: {
        type: Object,
        default: null
      },
      titulo: {
        type: String,
        default: 'Filhos'
      }
    },
    methods: {
      tratarDados (tipo, dado) {
        if (dado === null || dado === undefined || dado === '') {
          return 'Não informado'
        }

        switch (tipo) {
        case 'boolean':
          return this.formatarBoolean(dado)

        default:
          return dado
        }
      },
      formatarBoolean (boolean) {
        return boolean ? 'Sim' : 'Não'
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "@/scss/_utilities/_exports";

.section {
  &_header {
    @extend %titleBox;
    background-color: $color-gray-light;

    &_title {
      @extend %titleBox_title;
    }
  }
}

.BoxParte {
    box-shadow: 0 0 pxToRem(4) 0 $color-dark;

    &_error {
      border: solid 2px #8B0000;
    }

    &_header {
      background-color: #01AEC9;
      color: $color-dark;

      &_title {
        font-size: pxToRem(14);
        font-weight: 500;

      }
    }

    &_body {
      &_content {}
    }

    &_list {
      font-size: pxToRem(14);
      list-style: none;
      margin: 0;
      padding: 0;

      &_item {
        strong {
          text-transform: capitalize;
        }
      }

      &_title {
        margin-bottom: pxToRem(4);
        text-decoration: underline;
      }
    }
  }

</style>